import { Grid, IconButton, Box } from "@mui/material";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import AssignmentIcon from "@mui/icons-material/Assignment";
// import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState, useCallback } from "react";
import { getLawyersLawsuit } from "../../services/LawsuitService";
import { useNavigate } from "react-router-dom";
import DatagridCustom from "../General/DatagridCustom";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";

export default function ManagerLawyerLawsuit() {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [lawyers, setLawyers] = useState([]);
  // const [openSuccess, setOpenSuccess] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const { hasPermission } = useAuth();

  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: [],
  });

  const fetchLawyers = useCallback(async () => {
    setLoading(true);
    try {
      const { page, pageSize } = paginationModel;
      const searchTerm = filterModel.quickFilterValues?.join(" ") || "";

      const res = await getLawyersLawsuit({
        page: page + 1,
        perPage: pageSize,
        search: searchTerm,
      });

      setLawyers(res.data.data);
      setTotal(res.data.total);
    } catch (error) {
      console.error("[ManagerLegalFile] Error al cargar expedientes:", error);
      showToast(
        "No se pudieron cargar los expedientes. Intente de nuevo más tarde.",
      "error")
    } finally {
      setLoading(false);
    }
  }, [paginationModel, filterModel, showToast]);

  useEffect(() => {
    fetchLawyers();
  }, [paginationModel, filterModel, fetchLawyers]);

  const handleView = (id) => {
    navigate(`/lawsuit/lawyers/${id}`);
  };

  const handleFilterModelChange = useCallback(
    (newFilterModel) => {
      const currentSearchTerm = filterModel.quickFilterValues?.join(" ") || "";
      const newSearchTerm = newFilterModel.quickFilterValues?.join(" ") || "";

      setFilterModel(newFilterModel);

      if (currentSearchTerm !== newSearchTerm) {
        setPaginationModel((prev) =>
          prev.page !== 0 ? { ...prev, page: 0 } : prev,
        );
      }
    },
    [filterModel],
  );

  const columns = [
    {
      field: "updated_at",
      headerName: "Fecha de Actualización",
      flex: 1,
      valueGetter: (params) => {
        const date = new Date(params);

        if (isNaN(date.getTime())) {
          return "Fecha inválida";
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
      },
    },
    { field: "enrollment", headerName: "Matricula" },
    { field: "name", headerName: "Nombre", flex: 1 },
    { field: "lastname", headerName: "Apellido", flex: 1 },
    {
      field: "actions",
      headerName: "Acciones",
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton
            color="primary"
            onClick={() => handleView(params.row.id)}
            aria-label="ver"
            disabled={!hasPermission("ver demandas")}
          >
            <FindInPageIcon />
          </IconButton>
          {/* <IconButton
            color="error"
            onClick={() => handleDelete(params.row.id)}
            aria-label="eliminar"
            disabled={!hasPermission("eliminar expediente")}
          >
            <DeleteIcon />
          </IconButton> */}
        </>
      ),
    },
  ];

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>

        {/* <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}> */}
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <DatagridCustom
            rows={lawyers}
            columns={columns}
            title="Listado de Abogados - Ver Títulos"
            description="Visualice los abogados cargados en el sistema."
            icon={<AssignmentIcon sx={{ fontSize: 32 }} />}
            // error={globalError}
            // success={success}
            paginationModel={paginationModel}
            onPaginationChange={setPaginationModel}
            total={total}
            loading={loading}
            filterModel={filterModel}
            onFilterChange={handleFilterModelChange}
            filterMode="server"
            isServerPagination={true}
          />
        </Box>
        {/* </Paper> */}
      </Grid>
    </Grid>
  );
}
